import React from 'react';
import { motion } from 'framer-motion';
import { Box, Text } from '@chakra-ui/react';

const StyleSelector = ({ selectedStyle = 'women', onStyleChange, className = '' }) => {
  const handleStyleSelect = (style) => {
    onStyleChange(style);
  };

  return (
    <Box className={`${className}`}>
      <Text 
        className="block font-medium text-amber-800 mb-4 text-center"
        fontSize="sm"
      >
        Shopping for:
      </Text>
      
      <Box className="flex bg-orange-200 rounded-xl p-1 w-72 mx-auto relative border border-amber-300/20">
        {/* Active indicator */}
        <motion.div
          className="absolute top-1 bottom-1 bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-sm border border-rose-400/10"
          initial={false}
          animate={{
            left: selectedStyle === 'women' ? '4px' : '50%',
            width: 'calc(50% - 4px)'
          }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30
          }}
        />
        
        {/* Women's option */}
        <motion.button
          type="button"
          onClick={() => handleStyleSelect('women')}
          className={`flex-1 px-6 py-3 text-center font-medium rounded-lg transition-colors duration-200 relative z-10 ${
            selectedStyle === 'women'
              ? 'text-rose-900'
              : 'text-amber-700 hover:text-amber-900'
          }`}
          whileTap={{ scale: 0.98 }}
        >
          Women's Styles
        </motion.button>
        
        {/* Men's option */}
        <motion.button
          type="button"
          onClick={() => handleStyleSelect('men')}
          className={`flex-1 px-6 py-3 text-center font-medium rounded-lg transition-colors duration-200 relative z-10 ${
            selectedStyle === 'men'
              ? 'text-rose-900'
              : 'text-amber-700 hover:text-amber-900'
          }`}
          whileTap={{ scale: 0.98 }}
        >
          Men's Styles
        </motion.button>
      </Box>
    </Box>
  );
};

export default StyleSelector;